import { SiReact, SiFlask, SiAntdesign } from "react-icons/si";

// Features Data
export const featuresData = [
  {
    id: 1,
    icon: <SiReact />,
    title: "Front-End Web Dev",
    des: "Creating the user interface and user experience of a website, focusing on the visual elements and interactivity that users interact with directly in their web browsers.",
  },
  {
    id: 2,
    icon: <SiFlask />,
    title: "Back-End Web Dev",
    des: "Building and maintaining the server-side components of a website or web application that handle data, logic, and communication with the frontend.",
  },
  {
    id: 3,
    icon: <SiAntdesign />,
    title: "UI Design",
    des: "Creating user interfaces that enhance user experiences and interactions with digital products and services.",
  }
];
